import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "list-unstyled mb-2"
}
const _hoisted_3 = ["onClick", "title"]
const _hoisted_4 = ["href", "title"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "show-arrow font-weight-bold mb-3" }
const _hoisted_7 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_container = _resolveComponent("loading-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Anwendungsfavoriten", -1)),
    _createVNode(_component_loading_container, {
      state: _ctx.state,
      errormsg: "Beim Laden ist ein Fehler aufgetreten. Bitte probieren Sie es nochmals oder kontaktieren Sie den Help-Desk: help-desk@brz.gv.at"
    }, {
      default: _withCtx(() => [
        (_ctx.favourites.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.favourites, (favourite, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "show-arrow"
                }, [
                  (favourite.window && favourite.id && (favourite.id === 'OCT' || favourite.id === 'OCP'))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "#",
                        onClick: _withModifiers(($event: any) => (_ctx.openWindow(favourite)), ["prevent"]),
                        title: _ctx.getTooltip(favourite),
                        rel: "noreferrer noopener"
                      }, _toDisplayString(favourite.displayName), 9, _hoisted_3))
                    : (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: _ctx.sanitizeUrl(favourite.uri),
                        title: _ctx.getTooltip(favourite),
                        target: "_blank",
                        rel: "noreferrer noopener"
                      }, _toDisplayString(favourite.displayName), 9, _hoisted_4))
                ]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, " Keine Favoriten gesetzt. "))
      ]),
      _: 1
    }, 8, ["state"]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("a", {
        href: _ctx.sanitizeUrl(_ctx.urlAlleAnwendungen())
      }, "Alle Anwendungen", 8, _hoisted_7)
    ])
  ]))
}